import { callApiWithToken } from './base';
import config from '../../config';

export const fetchUsers = async (token: string) =>
  callApiWithToken(`${config.urls.users}`, token, 'GET');

export const setPerformanceUnitSite = async (
  token: string,
  user: number,
  performanceUnit: number,
  site: number,
) => {
  return callApiWithToken(
    `${config.urls.users}${user}/`,
    token,
    'PATCH',
    { 'Content-Type': 'application/json' },
    JSON.stringify({ performance_unit: performanceUnit, sites: [site] }),
  );
};

export const setMandatoryTraining = async (
  token: string,
  user: number,
  completed: boolean,
) => {
  return callApiWithToken(
    `${config.urls.users}${user}/`,
    token,
    'PATCH',
    { 'Content-Type': 'application/json' },
    JSON.stringify({ mandatory_training_completed: completed }),
  );
};

export const checkSelf = async (token: string) =>
  callApiWithToken(`${config.urls.users}self/`, token, 'GET');
